import React, { useState } from "react";
import { RadioIcon } from "lucide-react";
import { useHackathon } from "../../contexts/HackathonContext";
import { toEmbedUrl } from "../../utils/judging";
export function StreamPanel() {
  const {
    state,
    setStreamUrl
  } = useHackathon();
  const [draft, setDraft] = useState(state.streamUrl);
  const save = (e: React.FormEvent) => {
    e.preventDefault();
    setStreamUrl(draft.trim());
  };
  return <section aria-labelledby="stream-heading" data-id="element-99" data-mp="3mu7lse46d6ai">
      <div className="relative aspect-video w-full overflow-hidden rounded-2xl bg-navy" data-id="element-100" data-mp="3irt2jswlg4ip">
        {state.streamUrl ? <>
            <iframe src={toEmbedUrl(state.streamUrl)} title="Demo Day livestream" className="absolute inset-0 h-full w-full" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen data-id="element-101" data-mp="ev821ikm3vx" />
            <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-md bg-danger px-2 py-1 text-xs font-bold text-white" data-id="element-102" data-mp="2z4lmzrrpst31">
              <RadioIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-103" data-mp="23j45gaz2vq3o" />
              On air
            </span>
          </> : <div className="bg-waves absolute inset-0 flex flex-col items-center justify-center px-6 text-center text-white" data-id="element-104" data-mp="2db9y7mx5mbjx">
            <RadioIcon className="h-7 w-7 text-bryellow" aria-hidden="true" data-id="element-105" data-mp="2i92zq2niihdv" />
            <p id="stream-heading" className="mt-3 text-lg font-semibold" data-id="element-106" data-mp="1kmvx2yarqz45">
              Livestream not connected
            </p>
            <p className="mt-1 max-w-sm text-sm text-white/70" data-id="element-107" data-mp="1pm8hlce63u3k">
              Paste a YouTube Live, Vimeo or other embeddable link below to stream the pitches here.
            </p>
          </div>}
      </div>
      <form onSubmit={save} className="mt-3 flex gap-2" data-id="element-108" data-mp="1ynoqffpc3o5o">
        <label htmlFor="stream-url" className="sr-only" data-id="element-109" data-mp="3608ioqor1pse">
          Livestream link
        </label>
        <input id="stream-url" value={draft} onChange={e => setDraft(e.target.value)} placeholder="https://youtube.com/live/…" className="min-w-0 flex-1 rounded-lg border border-line bg-surface px-3 py-2 text-sm outline-none focus:border-ink" data-id="element-110" data-mp="3a0r7ebvcifqd" />
        <button type="submit" className="whitespace-nowrap rounded-lg bg-ink px-4 py-2 text-sm font-semibold text-white transition-colors duration-150 hover:bg-ink/85" data-id="element-111" data-mp="1jxh07q6hvemi">
          {state.streamUrl ? "Update" : "Connect"}
        </button>
      </form>
    </section>;
}